import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateBaseDataValuePipe'
})
export class TranslateBaseDataValuePipe implements PipeTransform {

  public transform(item: any, locale_id: string): string {
    return item?.translations?.length > 0 ? item?.translations?.find(x => x.locale_id === locale_id).translation : '-'
  }
}
